import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { TeamCheckService } from './team-check.service';
import { VideoLabService } from './video-lab.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TeamCheckGuard implements CanActivate {

  constructor(
    private teamCheckService: TeamCheckService,
    private router: Router,
    private videoLabService: VideoLabService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const videoId = route.paramMap.get('id');
    const internalBypassRequested = route.queryParamMap.get('internal_bypass') === '1';

    if (!videoId) {
      return true;
    }

    try {
      if (internalBypassRequested) {
        const isInternalUser = await firstValueFrom(this.videoLabService.checkInternalAccess());
        if (isInternalUser) {
          return true;
        }
      }

      const info = await this.teamCheckService.getInfo(videoId);

      // 1. Si ya está completado, permitir acceso a /analysis
      if (info.team_check_completed) {
        return true;
      }

      // 2. Si no, redirigir a la pantalla de team-check
      // CORRECCIÓN: Adaptado a la ruta { path: 'team-check/:id' }
      return this.router.createUrlTree(['/team-check', videoId]);

    } catch (error) {
      console.error('Error en TeamCheckGuard:', error);
      // En caso de error, dejamos pasar para no bloquear la navegación por un fallo de red
      return true;
    }
  }
}
